import React from "react";
import { MdPhone } from "react-icons/md";
import styled from "styled-components/macro";
import { BodyType, InnerBodiesByType, InnerBodyType } from "./types";
import MultisplitOptionTable from "components/multisplitOptionTable";
import { device } from "theme/Breakpoints";

interface Props {
  items?: InnerBodyType[];
}

const MultisplitOptions: React.FC<Props> = ({ items }) => {
  if (!items || Object.keys(items).length === 0) {
    return <></>;
  }

  const multipslitOptionsByType: InnerBodiesByType = items.reduce(
    (next, current) => {
      if (next[current.type]) {
        next[current.type].push(current);
      } else {
        next[current.type] = [current];
      }

      return next;
    },
    {} as InnerBodiesByType
  );

  return (
    <Container>
      <ContanctsStickyPanel>
        <PanelText>Изберете вътрешно тяло и ни се обадете</PanelText>
        <PhoneContainer href="tel:+359-886-560510">
          <MdPhone color="black" size="1.5em" />
          <PhoneNumber className="text-body">+359 889 269946</PhoneNumber>
        </PhoneContainer>
      </ContanctsStickyPanel>
      <TableContainer>
        {Object.values(BodyType).map((bodyType: BodyType, idx) => {
          const items = multipslitOptionsByType[bodyType];
          return (
            items && (
              <MultisplitOptionTable
                key={idx}
                items={multipslitOptionsByType[bodyType]}
              />
            )
          );
        })}
      </TableContainer>
    </Container>
  );
};

const Container = styled.div`
  margin: 40px 20px;
  display: flex;
  flex-flow: column;

  @media only screen and (${device.laptop}) {
    flex-flow: row nowrap;
  }
`;

const ContanctsStickyPanel = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  @media only screen and (${device.laptop}) {
    justify-content: flex-start;
    align-items: flex-start;
    width: 180px;
    padding: 8px;
    margin-bottom: 0;
  }

  @media only screen and (${device.laptopL}) {
    width: 230px;
    padding: 12px;
  }
`;
const PanelText = styled.div`
  color: black;
  font-weight: bold;
  margin-bottom: 20px;
`;
const PhoneContainer = styled.a`
  padding: 12px 8px;
  border-radius: 10px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  border: 2px black solid;
  text-decoration: none;
  transition: 0.2s all;

  &:hover {
    background-color: #4cda64;

    // span {
    //   color: white;
    // }

    // svg {
    //   fill: white;
    // }
  }

  & > svg {
    align-self: center;
  }

  & > span {
    align-self: center;
    font-weight: 700;
  }
`;

const PhoneNumber = styled.span`
  color: black;
`;

const TableContainer = styled.div`
  flex: 1;

  @media only screen and (${device.laptop}) {
    margin-left: 20px;
  }
`;

export default MultisplitOptions;
